@if (!(permitLoading$ | async)) {
  <div class="grid-container margin-top">
    @if (permit !== undefined) {
      <h2>API Well Number: {{ permit.apiNumber }}</h2>
      <div class="grid-x grid-margin-x">
        <div class="cell small-6">
          <div class="bold light-gray-bg">Owner Information</div>
          <div><label>Name:</label>{{ org.name }}</div>
          <div><label>DBA:</label>{{ booleanToYesNo(org.isDbaName) }}</div>
          <div>
            <p class="bold">Address:</p>
            <address-block [address]="org.address"></address-block>
          </div>
          <div><label>Email:</label>{{ org.email }}</div>
          <div><label>Phone:</label>{{ org.phone }}</div>
          <div><label>Fax:</label>{{ org.fax }}</div>
        </div>
        <div class="cell small-6">
          <div class="bold light-gray-bg">Permit Information</div>
          <div><label>Date Issued:</label>{{ permit.dateIssued | date: 'MM/dd/yyyy' }}</div>
          <div><label>Permit Expires:</label>{{ permit.dateOfExpiration | date: 'MM/dd/yyyy' }}</div>
          <div><label>Purpose of Well:</label>{{ wellType }}@if (wellTypeDescription != null) {
          ,
        } {{ wellTypeDescription }}</div>
        <div>
          <p class="bold">Special Permit Conditions:</p>
          @for (condition of permit.specialConditions; track condition) {
            <div>{{ condition }}</div>
          }
        </div>
      </div>
    </div>
    <div class="grid-x margin-top">
      <div class="cell small-12">
        <div class="bold light-gray-bg">Casing Plan & Map</div>
        <div class="bold">
          Casing Program (Casing must be centralized and is subject to approval of the Oil and Gas
          Inspector):
        </div>
        @for (segment of usableCasingStrings; track segment) {
          <div>
            @if (!segment.boreholeDiameter) {
              {{ segment.boreholeDiameter }}"
            }
            @if (segment.boreholeDiameter) {
              {{segment.casingDiameter}}"
            }
            {{ segment.casingType.definition }}
          </div>
        }
      </div>
      @if (casingPlan && casingPlan.schematic) {
        <div class="cell small-12 text-center">
          <img src="{{casingPlan.schematic}}" class="border-one-pixel-solid padding-all" />
        </div>
      } @else {
        <div class="cell small-12 text-center">
          No schematic available.
        </div>
      }
    </div>
    @if (wellHead != null) {
      <div class="grid-x grid-margin-x margin-top">
        <div class="cell small-12">
          <odnr-map [casingPlan]="casingPlan" [mode]="0" [longitude]="wellHeadLatitude" [latitude]="wellHeadLongitude"></odnr-map>
        </div>
        <!--<div class="cell small-6">
        <odnr-map [casingPlan]="casingPlan" [mode]="1" [longitude]="casingPlan.surfaceLongitude" [latitude]="casingPlan.surfaceLatitude"></odnr-map>
      </div>-->
    </div>
  }
  <div class="grid-x grid-margin-x margin-top">
    <div class="cell small-6">
      <div class="bold light-gray-bg">Designation</div>
      <div><label>Well Name:</label>{{ leaseName }} / {{ permit.wellNumber }}</div>
      <div><label>County:</label>{{ wellHead.county?.name | titlecase }}</div>
      <div><label>Civil Township:</label>{{ wellHead.township?.name | titlecase }}</div>
      <div><label>Tract or Allotment:</label>{{ wellHead.tract | titlecase }}</div>
      <!--<div><label>Surface Footage Location:</label>{{ wellHead?.footageCallsFromSectionLines }}</div>
      <div><label>Target Footage Location:</label>{{ target?.footageCallsFromSectionLines }}</div>-->
      <div><label>Drilling Unit Acres:</label>{{ permit.drillUnitAcres }}</div>
      <div><label>Proposed Total Depth:</label>{{ permit.proposal.totalDepth | number }}</div>
      <div>
        <label>Well location within an urbanized area as defined by <a target="_blank" href="/law-library/0oQOny0s6NhC0Sti">1509.01(y)</a>:</label>{{
        booleanToYesNo(permit?.location.isUrban)
        }}
      </div>
    </div>
    <div class="cell small-6">
      <div class="bold light-gray-bg">Location</div>
      <p class="bold">Surface:</p>
      <div><label>Latitude:</label>{{ wellHeadLatitude }}</div>
      <div><label>Longitude:</label>{{ wellHeadLongitude }}</div>
      @if (target) {
        <p class="bold">Target:</p>
        <div><label>Latitude:</label>{{ targetLatitude }}</div>
        <div><label>Longitude:</label>{{ targetLongitude }}</div>
      }
    </div>
  </div>
  <div class="grid-x grid-margin-x margin-top">
    <div class="cell small-6">
      <div class="bold light-gray-bg">Type of Tools</div>
      @for (segment of usableCasingStrings; track segment; let idx = $index) {
        <div> Segment {{ idx + 1 }} : {{ segment.drillingEquipment?.definition }}</div>
      }
    </div>
    <div class="cell small-6">
      <div class="bold light-gray-bg">Source(s) of Ground and/or Surface Water in Production Operation</div>
      @for (source of permit?.waterSources; track source; let i = $index) {
        <div>
          @if (i) {
            <div>
              <hr>
              </div>
            }
            <div><label>Source:</label>{{ source.source }}</div>
            <div><label>Watershed:</label>{{ getWatershed(source.watershed) }}</div>
            <div><label>Estimated Withdraw Rate (gal/day):</label>{{ source.estimatedWithdrawalRate | number }}</div>
            <div><label>Estimated Total Volume (gal):</label>{{ source.estimatedTotalVolume | number }}</div>
            <div><label>Estimated Recycled Total Volume (gal):</label>{{ source.recycledWaterVolume | number }}</div>
            <div></div>
          </div>
        }
      </div>
    </div>
    <div class="grid-x grid-margin-x margin-top">
      <div class="cell small-6">
        <div class="bold light-gray-bg">Emergency Contact Information</div>
        <div><label>Fire:</label>@if (fireDepartment.contactName !== '') {
        {{ fireDepartment.contactName }} :
      }{{ fireDepartment.phone }}</div>
      <div><label>Medical:</label>@if (medicalFacility.contactName !== '') {
      {{ medicalFacility.contactName }} :
    }{{ medicalFacility.phone }}</div>
    <div><label>Emergency Contact:</label>{{ emergencyContact?.contactName }}</div>
    <div><label>Emergency Contact Phone:</label>{{ emergencyContact?.phone }}</div>
  </div>
  <div class="cell small-6">
    <div class="bold light-gray-bg">Road and Land Use</div>
    @if (permit.roadMaintenanceAgreement) {
      <div><label>Agreement Reached:</label>{{ booleanToYesNo(permit.roadMaintenanceAgreement.wasReached) }}</div>
      <div><label>State Routes Only:</label>{{ booleanToYesNo(permit.roadMaintenanceAgreement.stateRoutesOnly) }}</div>
    }
    <div><label>Are the surface rights owned by the state of Ohio?</label>{{ booleanToYesNo(permit.surfaceRights?.stateOwnsRights) }}</div>
  </div>
</div>
<div class="grid-x grid-margin-x margin-top">
  <div class="cell small-6">
    <div class="bold light-gray-bg">Oil & Gas Well Inspector</div>
    <div><label>{{ permit.inspectors.inspectorName }}:</label>{{ permit.inspectors.inspectorPhone }}</div>
    <div><label>{{ permit.inspectors.supervisorName }} (Supervisor):</label>{{ permit.inspectors.supervisorPhone }}</div>
    <div><label>District #:</label>{{ permit.inspectors.regionalPhone }}</div>
    <div>
      <p class="bold">The inspector needs to be notified within 24 hours prior to:</p>
      <ol>
        @for (reason of dayNotifyReasons; track reason) {
          <li>{{reason}}</li>
        }
      </ol>
    </div>
    <div>
      <p class="bold">The inspector needs to be notified immediately upon:</p>
      <ol>
        @for (reason of immediateNotifyReasons; track reason) {
          <li>
            {{reason}}
          </li>
        }
      </ol>
    </div>
  </div>
  <div class="cell small-6">
    <div class="bold light-gray-bg">Chief Signature</div>
    <div><label>Digitally Signed by:</label></div>
    @if (permit?.chiefsSignature) {
      <div class="signature">{{ permit?.chiefsSignature }}</div>
      <!--<div>{{ title }}</div>-->
    } @else {
      No signature currently associated with this permit.
    }
  </div>
</div>
}
@if (permit === undefined) {
  Unable to load permit details.
}
</div>
} @else {
  <div class="grid-container v-pad text-align-center">
    <div>
      Getting permit details... please wait...
    </div>
  </div>
}
<a style="display:none" href="" target="_blank" #downloadLink></a>



